'use client';

import Link from 'next/link';
import { Button } from './_components/ui/button';
import Image from 'next/image';
import { cn } from '@lib/utils';

export default function GlobalError({ error: _err }: { error: Error & { digest?: string }; reset: () => void }) {
  console.error(_err);
  return (
    <html>
      <body className="flex min-h-screen flex-col space-y-3">
        <div className={cn('relative mt-20 h-32 w-auto')}>
          <Image
            src={'/images/error.svg'}
            className="h-auto w-full object-contain"
            fill
            alt="Internal Server Error"
          />
        </div>
        <h2>Oopss... terjadi masalah, Silahkan lakukan Relogin</h2>
        <Link href={'/auth/login'}>
          <Button>Relogin</Button>
        </Link>
      </body>
    </html>
  );
}
